<template>
  <v-content>
    <v-container fluid>
      <v-card class="elevation-5">
        <v-toolbar dense dark color="deep-orange" elevation="2">
          <v-toolbar-title>Configuración de Marca de Agua</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text :loading="saving" :disabled="loading" @click="guardar()">
            <v-icon left>mdi-content-save</v-icon>
            GUARDAR
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-alert type="info" outlined dense>
                Configure qué elementos se mostrarán en la marca de agua de las
                fotos. Los cambios aplican a todas las fotos que se visualicen
                con marca de agua activa.
              </v-alert>
            </v-col>
          </v-row>

          <v-row v-if="loading" justify="center" class="my-5">
            <v-progress-circular
              indeterminate
              color="deep-orange"
            ></v-progress-circular>
          </v-row>

          <v-row v-else>
            <v-col cols="12" md="6">
              <v-card outlined>
                <v-card-title class="subtitle-1">
                  <v-icon left color="deep-orange">mdi-map-marker</v-icon>
                  Ubicación
                </v-card-title>
                <v-card-text>
                  <v-switch
                    v-model="configuracion.mapa"
                    label="Mostrar mapa"
                    color="deep-orange"
                    hide-details
                    class="mt-0"
                  ></v-switch>
                  <v-switch
                    v-model="configuracion.coordenadas"
                    label="Mostrar coordenadas"
                    color="deep-orange"
                    hide-details
                  ></v-switch>
                  <v-switch
                    v-model="configuracion.direccion"
                    label="Mostrar dirección"
                    color="deep-orange"
                    hide-details
                  ></v-switch>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="6">
              <v-card outlined>
                <v-card-title class="subtitle-1">
                  <v-icon left color="deep-orange">mdi-information</v-icon>
                  Información General
                </v-card-title>
                <v-card-text>
                  <v-switch
                    v-model="configuracion.fecha"
                    label="Mostrar fecha y hora"
                    color="deep-orange"
                    hide-details
                    class="mt-0"
                  ></v-switch>
                  <v-switch
                    v-model="configuracion.tienda"
                    label="Mostrar tienda"
                    color="deep-orange"
                    hide-details
                  ></v-switch>
                  <v-switch
                    v-model="configuracion.plaza"
                    label="Mostrar plaza"
                    color="deep-orange"
                    hide-details
                  ></v-switch>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="6">
              <v-card outlined>
                <v-card-title class="subtitle-1">
                  <v-icon left color="deep-orange">mdi-clipboard-text</v-icon>
                  Encuesta y Actividad
                </v-card-title>
                <v-card-text>
                  <v-switch
                    v-model="configuracion.encuesta"
                    label="Mostrar encuesta"
                    color="deep-orange"
                    hide-details
                    class="mt-0"
                  ></v-switch>
                  <v-switch
                    v-model="configuracion.actividad"
                    label="Mostrar actividad"
                    color="deep-orange"
                    hide-details
                  ></v-switch>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="6">
              <v-card outlined>
                <v-card-title class="subtitle-1">
                  <v-icon left color="deep-orange">mdi-account-group</v-icon>
                  Usuario y Empresa
                </v-card-title>
                <v-card-text>
                  <v-switch
                    v-model="configuracion.usuario"
                    label="Mostrar usuario"
                    color="deep-orange"
                    hide-details
                    class="mt-0"
                  ></v-switch>
                  <v-switch
                    v-model="configuracion.empresa"
                    label="Mostrar empresa"
                    color="deep-orange"
                    hide-details
                  ></v-switch>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-snackbar
        v-model="snackbar"
        :color="snackbarColor"
        :timeout="3000"
        bottom
        right
      >
        {{ snackbarMessage }}
      </v-snackbar>
    </v-container>
  </v-content>
</template>

<script>
import services from "@/utils/services";

export default {
  name: "ConfiguracionMarcaAgua",
  data: () => ({
    loading: false,
    saving: false,
    snackbar: false,
    snackbarMessage: "",
    snackbarColor: "success",
    configuracion: {
      mapa: true,
      fecha: true,
      coordenadas: true,
      tienda: true,
      direccion: true,
      encuesta: true,
      actividad: true,
      empresa: true,
      usuario: true,
      plaza: true,
    },
  }),
  mounted() {
    this.cargar();
  },
  methods: {
    async cargar() {
      this.loading = true;
      try {
        const response = await services.ws("get", "configuracionMarcaAgua", {});
        if (response.ok) {
          this.configuracion = {
            ...this.configuracion,
            ...response.data.configuracion,
          };
        } else {
          this.mostrarError(
            response.message || "Error al cargar la configuración"
          );
        }
      } catch (error) {
        console.error(error);
        this.mostrarError("Error al cargar la configuración");
      } finally {
        this.loading = false;
      }
    },
    async guardar() {
      this.saving = true;
      try {
        const response = await services.ws(
          "post",
          "actualizarConfiguracionMarcaAgua",
          {
            configuracion: this.configuracion,
          }
        );
        if (response.ok) {
          this.mostrarExito("Configuración guardada correctamente");
        } else {
          this.mostrarError(response.message || "Error al guardar");
        }
      } catch (error) {
        console.error(error);
        this.mostrarError("Error al guardar la configuración");
      } finally {
        this.saving = false;
      }
    },
    mostrarExito(mensaje) {
      this.snackbarColor = "success";
      this.snackbarMessage = mensaje;
      this.snackbar = true;
    },
    mostrarError(mensaje) {
      this.snackbarColor = "error";
      this.snackbarMessage = mensaje;
      this.snackbar = true;
    },
  },
};
</script>
